module.exports = __webpack_public_path__ + "static/fonts/AvenirLTProHeavy.06c50d0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTProHeavy.ttf
// module id = n24R
// module chunks = 1